import { render, staticRenderFns } from "./FormNumber.vue?vue&type=template&id=1d28a406&"
import script from "./FormNumber.vue?vue&type=script&lang=ts&"
export * from "./FormNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports